import { ConstructionAreaLocation, PolygonPoint } from '@shared/models';

export function getBoundingBox(
  points?: PolygonPoint[]
): { x: number; y: number; width: number; height: number } | null {
  if (!points || points.length === 0) return null;

  const xs = points.map((p) => p.x);
  const ys = points.map((p) => p.y);
  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const minY = Math.min(...ys);
  const maxY = Math.max(...ys);

  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY,
  };
}

export function getGlobalBoundingBox(
  locations: ConstructionAreaLocation[]
): { x: number; y: number; width: number; height: number } | null {
  const allPoints = locations.flatMap((loc) => loc.points || []);
  if (allPoints.length === 0) return null;
  return getBoundingBox(allPoints);
}
